import { useState } from "react";
import { X, Calendar, Clock } from "lucide-react";

const durationOptions = [
  { label: "1 hour", hours: 1 },
  { label: "2 hours", hours: 2 },
  { label: "4 hours", hours: 4 },
  { label: "8 hours (full day)", hours: 8 },
];

export default function BookingModal({ machine, centre, onClose, onConfirm }) {
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("09:00");
  const [duration, setDuration] = useState(2);
  const [notes, setNotes] = useState("");

  const estimatedTotal = machine.hourlyRate * duration;

  const handleConfirm = () => {
    onConfirm?.({ machine, date, startTime, duration, notes, estimatedTotal });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md">
        <div className="flex items-start justify-between mb-1.5">
          <h2 className="text-lg font-bold text-gray-900">Book {machine.name}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-sm text-gray-500 mb-5">
          APIC {centre} · ₹{machine.hourlyRate}/hr — you'll receive confirmation from the centre.
        </p>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Date</label>
            <div className="flex items-center gap-2 border border-gray-300 rounded-xl px-3 py-2">
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                className="w-full text-sm focus:outline-none"
              />
              <Calendar className="w-4 h-4 text-gray-400 shrink-0" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Start time</label>
            <div className="flex items-center gap-2 border border-gray-300 rounded-xl px-3 py-2">
              <input
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                className="w-full text-sm focus:outline-none"
              />
              <Clock className="w-4 h-4 text-gray-400 shrink-0" />
            </div>
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Duration</label>
          <select
            value={duration}
            onChange={(e) => setDuration(Number(e.target.value))}
            className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm focus:outline-none"
          >
            {durationOptions.map((d) => (
              <option key={d.hours} value={d.hours}>
                {d.label}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Purpose / Notes</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Prototype job, material, project ID..."
            rows={3}
            className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none resize-none"
          />
        </div>

        <div className="flex items-center justify-between bg-gray-50 rounded-xl px-4 py-3 mb-5">
          <span className="text-sm text-gray-600">Estimated total</span>
          <span className="font-bold text-blue-600">₹{estimatedTotal.toLocaleString("en-IN")}</span>
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2.5 rounded-xl border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="px-4 py-2.5 rounded-xl bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-sm font-semibold hover:opacity-90"
          >
            Confirm booking
          </button>
        </div>
      </div>
    </div>
  );
}